import { render, staticRenderFns } from "./big_screen.vue?vue&type=template&id=7b30514e&scoped=true&"
import script from "./big_screen.vue?vue&type=script&lang=ts&"
export * from "./big_screen.vue?vue&type=script&lang=ts&"
import style0 from "./big_screen.vue?vue&type=style&index=0&id=7b30514e&lang=scss&scoped=true&"
import style1 from "./big_screen.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b30514e",
  null
  
)

export default component.exports